import {
  useCreateOrderAdjustment,
  useGetOrderAdjustment,
} from 'api-hooks/order-adjustment';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import OrderAdjustmentForm from './components/form';

export type OrderAdjustmentsViewParams = {
  id: string;
};

export default function OrderAdjustmentsView(
  props: NavigationProps<NavigationRoutes.OrderAdjustmentView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetOrderAdjustment(
    {
      id,
    },
  );

  const { mutateAsync: updateMutate, error: updateError } =
    useCreateOrderAdjustment();

  const orderAdjustment = data?.data;

  const onResolve = useApprovalableEdit('order-adjustments');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <OrderAdjustmentForm
            {...props}
            orderAdjustment={orderAdjustment}
            renderError={
              !!updateError &&
              !!updateError.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => updateError.message}
                  </Notification>
                </>
              )
            }
            onSubmit={async (input, form) => {
              const result = await updateMutate(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
